import Vue from "vue"

import Percentage from './percentage'
import Round from './round'
import Uppercase from './uppercase'
import Titlecase from './titlecase'
import Stringify from './stringify'
import Jsonify from './jsonify'
import CommaSep from './commasep'
import Currency from './currency'

Vue.filter('uppercase', Uppercase);
Vue.filter('titlecase', Titlecase);
Vue.filter('percentage', Percentage);
Vue.filter('round', Round);
Vue.filter('stringify', Stringify);
Vue.filter('jsonify', Jsonify);
Vue.filter('commasep', CommaSep)
Vue.filter('currency', Currency)

export default {
  Percentage,
  Round,
  Uppercase,
  Titlecase,
  Stringify,
  Jsonify,
  CommaSep,
  Currency
}
